import { Stack, styled } from "@mui/material";

export const PageWrapper = styled(Stack)`
  background-color: ${({ theme }) => theme.palette.background.default};
  padding: 2rem;
  padding-top: 0rem;
  flex: 1;
`;
